import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PoolsInterface } from "interfaces/retrieve";
import { RootState } from "app/store";

interface PoolsState {
  pools: PoolsInterface[];
}

export const initialState: PoolsState = {
  pools: [],
};

export const poolsSlice = createSlice({
  name: "pools",
  initialState,
  reducers: {
    setPools: (state, action: PayloadAction<PoolsInterface[]>) => {
      state.pools = action.payload;
    },
  },
});

export const selectPoolsState = (state: RootState) => state.pools;

export const { setPools } = poolsSlice.actions;

export default poolsSlice.reducer;
